var $0b4f3a4ee068274f$exports = {};
$0b4f3a4ee068274f$exports = {
    "removeButtonLabel": `\u{C81C}\u{AC70}`,
    "removeDescription": `\u{D0DC}\u{ADF8}\u{B97C} \u{C81C}\u{AC70}\u{D558}\u{B824}\u{BA74} Delete \u{D0A4}\u{B97C} \u{B204}\u{B974}\u{C2ED}\u{C2DC}\u{C624}.`
};


export {$0b4f3a4ee068274f$exports as default};
//# sourceMappingURL=ko-KR.mjs.map
